import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import $ from 'jquery';

import BuildingHeader from '../buildings/BuildingHeader';
import useAuth from '../../controllers/users/useAuth';
import { purchaseExpenseConceptsGetAsync, purchasePaymentDataGetAsync, purchaseSuppliersGetAsync, purchaseTaxesGetAsync } from '../../controllers/purchases/purchases';
import {
    checkIfUserIsMaster, dataTableLanguaje, buttonProcessGet, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync,
    dateTimeFormatGlobalSet, separatorsNumbersSet, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import Menu from '../main/Menu';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { purchaseModelGet } from '../../models/expenses/purchase';

const currentMethod = 'Purchases';

const { backend, } = globalSettings?.app;
const { icons, labels, messages, } = globalSettings;
const { properties: dbProps, } = globalSettings?.collections;
const { operators: dbOpera, } = globalSettings?.react?.firebase;

export default function Purchases({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region others
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    //const history = useHistory();
    let swalProperties = {};
    //const [showData, setShowData] = useState(false);
    const [showLoading, setShowLoading] = useState({ buildings: true, purchases: true, });
    const [btnAddDisabled, setBtnAddDisabled] = useState(true);
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    //#endregion others

    //#region purchases
    //let purchases = [];
    const dtPurchasesId = 'dtPurchases';
    //#endregion purchases

    //#region buildings
    const buildingsId = 'buildings';
    const [building, setBuilding] = useState({});
    const [buildings, setBuildings] = useState([]);
    //const [buildingId, setBuildingId] = useState('');
    //#endregion buildings

    //#region others
    const controls = {
        buttons: {
            // save: {
            //     id: 'btnCreate',
            //     className: 'btn btn-outline-warning mx-1',
            // },
            // back: {
            //     id: 'btnBack',
            //     className: '',
            // },
            // close: {
            //     id: 'btnClose',
            //     className: 'close btn-danger fas fa-window-close',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            purchases: {
                buttons: {
                    create: {
                        className: 'btn btn-outline-success float-right btn-sm',
                        id: 'btnDtPurchasesIdCreate',
                    },
                },
                icons: {
                    create: {
                        id: 'iconDtPurchasesIdCreate',
                        className: icons?.plusCircle,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtPurchasesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtPurchasesId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    create: {
                        id: 'spDtPurchasesIdCreate',
                        className: '',
                    },
                },
            },
        },
        icons: {
            // save: {
            //     id: 'icoSave',
            //     className: icons?.save,
            // },
            // back: {
            //     id: 'icoBack',
            //     className: icons?.arrowCircleLeft,
            // },
            // close: {
            //     id: 'icoClose',
            //     className: icons?.plusCircle,
            // },
        },
        inputs: {
            // user: {
            //     id: 'inputUser',
            //     className: 'form-control bg-transparent',
            // },
            // title: {
            //     id: 'inputTitle',
            //     className: 'form-control bg-transparent',
            // },
            // comment: {
            //     id: 'inputComment',
            //     className: 'form-control',
            // },
            // statusComment: {
            //     id: 'inputStatusComment',
            //     className: 'form-control bg-transparent text-black',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            // save: {
            //     id: 'spSave',
            //     className: '',
            // },
            // back: {
            //     id: 'spBack',
            //     className: '',
            // },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region purchases (methods)
    const dataTablePurchasesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablePurchasesSetAsync';
        let response = responseGet();
        try {
            $(`#${dtPurchasesId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.number?.[languageObj?.id], width: '10%', },
                    { title: labels?.date?.[languageObj?.id], orderable: false, width: '15%', },
                    { title: labels?.supplier?.[languageObj?.id], width: '40%', },
                    { title: labels?.balance?.[languageObj?.id], className: 'text-right', width: '15%', },
                    { title: labels?.total?.[languageObj?.id], className: 'text-right', width: '15%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'desc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtPurchasesId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const purchasesGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'purchasesGetAsync'
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRows = [];
            let isEditLocal = false;
            let buildingIdLocal = '';
            let isDeleteLocal = false;
            let buildingLocal = buildingModelGet({});
            let purchasesLocal = [purchaseModelGet({})];
            //#endregion variables

            setShowLoading({ buildings: false, purchases: true, });

            //#region initialize
            //purchases = [];
            setBuilding({});
            setBtnAddDisabled(true);
            $(`#${dtPurchasesId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            //#endregion initialize

            //#region purchases get
            //#region old code
            // if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
            //     buildingIdLocal = e?.target?.value;
            //     setBuildingId(buildingIdLocal);
            // } else {
            //     buildingIdLocal = buildingId;
            // }
            //#endregion old code
            buildingIdLocal = $(`#${buildingsId}`)?.val();

            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod })?.result) {
                //#region building get
                buildingLocal = buildings.find(({ id }) => id === buildingIdLocal) || {};
                setBuilding(buildingLocal);
                //#endregion building get

                if (!isUndNullEmp({ data: buildingLocal, subMethod: currentMethod })?.result) {
                    //#region  Get purchases
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    dataObj = {
                        limit: 0,
                        buildingId: buildingIdLocal,
                        ordersBy: [
                            { field: dbProps?.number, value: 'asc' },
                        ],
                        conditionals: [
                            { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingIdLocal, },
                        ],
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlPurchases}/`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ buildings: false, purchases: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    purchasesLocal = response?.result || [];
                    //#endregion  Get purchases
                    //#region purchase adds dtTable (purchases)

                    //#region create extra buttons
                    const processButtons = [];
                    processButtons?.push({
                        showDivider: true,
                        isVisible: true,
                        isEnabled: true,
                        methodName: 'payments',
                        icon: icons?.handHoldingUsd,
                        label: labels?.payments?.[languageObj?.id],
                    });
                    //#endregion create extra buttons

                    purchasesLocal?.forEach((detail) => {
                        dtRows.push([
                            detail?.number,
                            dateTimeFormatGlobalSet({
                                date: detail?.date,
                                type: languageObj?.format?.date?.f1,
                                format: 0,
                                addTime: false,
                                secondsShow: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            detail?.supplier?.description,
                            separatorsNumbersSet({
                                number: detail?.balance,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            })?.result,
                            separatorsNumbersSet({
                                number: detail?.total,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            })?.result,
                            buttonProcessGet({
                                id: detail?.id,
                                description: detail?.number,
                                showDetails: true,
                                labelDetails: labels?.detail?.[languageObj?.id],
                                enabledDetails: true,
                                showEdit: true,
                                labelEdit: labels?.edit?.[languageObj?.id],
                                enabledEdit: processEvaluateGet({
                                    object: detail,
                                    property: labels?.process?.en?.toLowerCase(),
                                    process: labels?.edit?.en?.toLowerCase(),
                                    subMethod: currentMethod,
                                })?.result,
                                showDelete: true,
                                labelDelete: labels?.delete?.[languageObj?.id],
                                enabledDelete: processEvaluateGet({
                                    object: detail,
                                    property: labels?.process?.en?.toLowerCase(),
                                    process: labels?.delete?.en?.toLowerCase(),
                                    subMethod: currentMethod,
                                })?.result,
                                processButtons: processButtons,
                            })?.result,
                        ]);
                    });

                    //#endregion purchase adds dtTable (purchases)
                    //#region check is enebled btnAdd
                    isEditLocal = processEvaluateGet({
                        object: buildingLocal,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result;

                    isDeleteLocal = isEditLocal;
                    //#endregion check is enebled btnAdd

                    setBtnAddDisabled(!(isEditLocal && isDeleteLocal));
                }
            }
            //#endregion purchases get

            //#region dataTables set / datatable clear / set data in datatable
            //#region old code
            // response = localDataTableClears(true);
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading(false);

            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }
            //#endregion old code

            $(`#${dtPurchasesId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion dataTables set / datatable clear / set data in datatable

            setShowLoading({ buildings: false, purchases: false, });
        } catch (ex) {
            setBtnAddDisabled(true);
            setShowLoading({ buildings: false, purchases: false, });

            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const purchaseAddDetailsEditGetAsync = async ({ e, id = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'purchaseAddDetailsEditGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            //#region building validate
            if (processType === 0) {
                if (isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 1,
                        msgText: messages?.youMustSelectBuilding?.[languageObj?.id],
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
            }
            //#endregion building validate

            if (processType === 0) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
            } else if (processType >= 1 && processType <= 3) {
                setShowLoading({ buildings: false, purchases: true, });
            }

            //#region purchase get
            if (processType !== 0) {
                response = await purchaseByIdGetAsync({
                    id: id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    if (processType === 0) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    } else if (processType >= 1 && processType <= 3) {
                        setShowLoading({ buildings: false, purchases: false, });
                    }
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
            }
            //#endregion purchase get

            //#region suppliers check
            response = await purchaseSuppliersGetAsync({
                buildingId: buildingIdLocal,
                limit: 0,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                if (processType === 0) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                } else if (processType >= 1 && processType <= 3) {
                    setShowLoading({ buildings: false, purchases: false, });
                }
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion suppliers check

            //#region taxes check
            response = await purchaseTaxesGetAsync({
                buildingId: buildingIdLocal,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                if (processType === 0) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                } else if (processType >= 1 && processType <= 3) {
                    setShowLoading({ buildings: false, purchases: false, });
                }
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion taxes check

            //#region check expense concepts
            response = await purchaseExpenseConceptsGetAsync({
                buildingId: buildingIdLocal,
                isConceptsDt: false,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                if (processType === 0) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                } else if (processType >= 1 && processType <= 3) {
                    setShowLoading({ buildings: false, purchases: false, });
                }
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion check expense concepts

            //#region purchase get
            switch (processType) {
                case 0:
                    window.location.href = `${backend?.urlPurchaseAdd}/${buildingIdLocal}`
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    break;
                case 1:
                    window.location.href = `${backend?.urlPurchaseEdit}/${id}`
                    setShowLoading({ buildings: false, purchases: false, });
                    break;
                case 2:
                    window.location.href = `${backend?.urlPurchaseDetail}/${id}`
                    setShowLoading({ buildings: false, purchases: false, });
                    break;
                case 3:
                    //#region payment data check
                    response = await purchasePaymentDataGetAsync({
                        buildingId: buildingIdLocal,
                        limit: 1,
                        valueReturn: false,
                        auth: auth,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ buildings: false, purchases: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }
                    //#endregion payment data check

                    window.location.href = `${backend?.urlPurchasePayments}/${id}`;
                    setShowLoading({ buildings: false, purchases: false, });
                    break;
                default:
                    break;
            }

            //#endregion purchase get
        } catch (ex) {
            if (processType === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else if (processType >= 1 && processType <= 3) {
                setShowLoading({ buildings: false, purchases: false, });
            }
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const purchaseDeleteAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'purchaseDeleteAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region old code
            // //#region variables
            // let localMsgText = '';
            // //#endregion variables

            // //#region show message
            // localMsgText = `${labels?.purchase?.[languageObj?.id]}: <b>${description}</b><br/>`;
            // localMsgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

            // swalProperties = {
            //     icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
            //     title: messages?.areYouSureDeleteThis?.[languageObj?.id],
            //     html: localMsgText,
            //     timer: null,
            //     confirmButtonColor: globalSettings?.colors?.warningColorExp,
            //     confirmButtonText: labels?.yes?.[languageObj?.id],
            //     showCancelButton: true,
            //     cancelButtonColor: globalSettings?.colors?.successColorExp,
            //     cancelButtonText: labels?.no?.[languageObj?.id],
            //     timerProgressBar: false,
            //     didOpen: () => {
            //         Swal.hideLoading();
            //     },
            // };

            // const { isConfirmed, } = await Swal.fire(swalProperties);
            // //#endregion show message

            // //#region delete data
            // if (isConfirmed) {
            //     sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

            //     //#region delete purchase
            //     headerObj = {
            //         headers: {
            //             authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //         },
            //     };

            //     //result = await axios.delete(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlPurchases}/${id}`, headerObj);
            //     result = await axios.delete(`${backend?.url}${backend?.urlApiV1}${backend?.urlPurchases}/${id}`, headerObj);
            //     response = result.data;

            //     if (!response?.isSuccess || response?.isWarning) {
            //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //         return;
            //     }
            //     //#endregion delete purchase

            //     //#region delete purchase (dataTable)
            //     $(`#${dtPurchasesId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
            //     //#endregion delete purchase (dataTable)

            //     sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            // }
            // //#endregion delete data
            //#endregion old code

            //#region show message
            let msgTextObj = {
                one: `${labels?.purchase?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}`,
                            showConfirmButton: false,
                        });

                        //#region purchases delete
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlPurchases}/${id}`,
                        };

                        result = await axios?.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion purchase delete

                        //#region dtPurchases update
                        $(`#${dtPurchasesId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                        //#endregion dtPurchases update

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const purchaseByIdGetAsync = async ({ id = '', subMethod = '', }) => {
        const currentMethod = 'purchaseByIdGetAsync';
        let response = responseGet();
        try {
            //#region purchase get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlPurchases}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion purchase get
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion purchases (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ buildings: true, purchases: true, });

            //#region inicialize
            setBtnAddDisabled(true);
            //#endregion inicialize

            //#region buildings get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlPurchases,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, purchases: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings);
            }
            //#endregion buildings get

            //#region dataTable set / clear datatable
            response = await dataTablesSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, purchases: false, });
                return;
            }

            //#region old code
            // response = localDataTableClears(true);
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading(false);
            //     
            //     await sendMessageCloseCurrentWindowAsync({
            //         msgType: response?.msgType,
            //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //         closeWindow: false,
            //         urlGoTo: response?.urlGoTo,
            //         auth: auth,
            //         isLogout: false,
            //         languageId: languageObj?.id,
            //         subMethod: currentMethod,
            //     });
            //     return;
            // }
            //#endregion old code
            //#endregion dataTable set / clear datatable

            setShowLoading({ buildings: false, purchases: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, purchases: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            response = await dataTablePurchasesSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = await queryCodeSetAsync({ subMethod: '', });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region purchases
            $(`#${dtPurchasesId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtPurchasesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value;
                    method = e?.target?.attributes?.method?.value;
                    description = e?.target?.attributes?.description?.value;
                    switch (method) {
                        case 'details':
                            purchaseAddDetailsEditGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'edit':
                            purchaseAddDetailsEditGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            purchaseDeleteAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case 'payments':
                            purchaseAddDetailsEditGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 3, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion purchases
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    //#region old code
    // const localDataTableClears = (dtPurchases = false) => {
    //     let response = responseGet();
    //     try {
    //         if (dtPurchases) {
    //             $(`#${dtPurchasesId}`)?.DataTable()?.rows()?.clear()?.draw(true);
    //         }
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localDataTableClears<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.purchases?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchases?.buttons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchases?.spinners?.create?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.purchases?.icons?.create?.id}`)?.addClass(controls?.dataTables?.purchases?.icons?.create?.className);
                    $(`#${controls?.dataTables?.purchases?.buttons?.create?.id}`)?.addClass(controls?.dataTables?.purchases?.buttons?.create?.className);
                    $(`#${controls?.dataTables?.purchases?.spinners?.create?.id}`)?.addClass(controls?.dataTables?.purchases?.spinners?.create?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.purchases?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchases?.spinners?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.purchases?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.purchases?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.purchases?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', })
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='expenses' process='purchases' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.purchases?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.purchases?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {/*buildings*/}
                        <BuildingHeader buildingsId={buildingsId}
                            building={building}
                            buildings={buildings}
                            btnSyncDisabled={btnAddDisabled}
                            methodGetAsync={purchasesGetAsync}
                            processType={0}
                            showLoading={showLoading?.buildings}
                            headerSectionValues={{}} />

                        {/*purchases*/}
                        <div className='row'>
                            <div className='col-12'>

                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.purchases}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.purchases?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.invoiceLogo}></img> - {labels?.purchases?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            {/* {!showLoading ? */}
                                            <div className='col-md-12'>
                                                {/* {showData ? */}
                                                {/* <div> */}
                                                <button id={controls?.dataTables?.purchases?.buttons?.create?.id}
                                                    className={controls?.dataTables?.purchases?.buttons?.create?.className}
                                                    tooltip='tooltip'
                                                    title={labels?.create?.[languageObj?.id]}
                                                    disabled={btnAddDisabled}
                                                    onClick={(e) => purchaseAddDetailsEditGetAsync({ e: e, id: '', description: '', rowIndex: 0, processType: 0, subMethod: 'btn - purchaseAdd', })}>
                                                    <i id={controls?.dataTables?.purchases?.icons?.create?.id} className={controls?.dataTables?.purchases?.icons?.create?.className} /> <span id={controls?.dataTables?.purchases?.spinners?.create?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtPurchasesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                                {/* </div> */}
                                                {/* : */}
                                                {/* <div></div> */}
                                                {/* } */}
                                            </div>
                                            {/* : */}
                                            {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={globalSettings?.colors?.infoColorExp}
                                                    msgText={messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} /> */}
                                            {/* } */}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </section>

            </div>

        </div>
    )
}